export var ChecksumAlgorithm = /*#__PURE__*/function (ChecksumAlgorithm) {
  ChecksumAlgorithm["MD5"] = "MD5";
  ChecksumAlgorithm["CRC32"] = "CRC32";
  ChecksumAlgorithm["CRC32C"] = "CRC32C";
  ChecksumAlgorithm["SHA1"] = "SHA1";
  ChecksumAlgorithm["SHA256"] = "SHA256";
  return ChecksumAlgorithm;
}(ChecksumAlgorithm || {});
export var ChecksumLocation = /*#__PURE__*/function (ChecksumLocation) {
  ChecksumLocation["HEADER"] = "header";
  ChecksumLocation["TRAILER"] = "trailer";
  return ChecksumLocation;
}(ChecksumLocation || {});
export const DEFAULT_CHECKSUM_ALGORITHM = ChecksumAlgorithm.MD5;
export const S3_EXPRESS_DEFAULT_CHECKSUM_ALGORITHM = ChecksumAlgorithm.CRC32;